import type { QueryClient } from "@tanstack/react-query";

import { buildingApi } from "~/api";

const APP_TITLE = "Plateforme | Eisox";

interface DocumentTitleParts {
  page?: string;
  building?: string;
}

export const formatDocumentTitle = ({ page, building }: DocumentTitleParts = {}) =>
  [page, building, APP_TITLE]
    .map(part => part?.trim())
    .filter(Boolean)
    .join(" - ");

export const documentTitleHead = (parts?: DocumentTitleParts) => ({
  meta: [{ title: formatDocumentTitle(parts) }],
});

export const buildingPageHead = async (queryClient: QueryClient, buildingId: string, page?: string) => {
  const building = await queryClient.ensureQueryData(buildingApi.queries.byId(buildingId));
  return documentTitleHead({ page, building: building.name });
};
